/* FIVE AM · Vista rápida («Échale un ojo»), 19/09/2026.
   Todo «Échale un ojo» y todo «Elegir talla» de snippets/fa-card-actions (portada, colecciones, búsqueda, recomendados)
   abre aquí, en un <dialog> propio, el HTML de sections/fa-quick para la URL de la tarjeta, que ya lleva la variante de la
   muestra elegida. El clic se corta en captura para que no llegue a la vista rápida de Horizon.
   La compra la hace el product-form-component de Horizon que va dentro, así que la cesta y el cajón se enteran igual que
   con cualquier «Añadir». Se precarga al pasar el ratón por la tarjeta: al pulsar, la vista suele estar ya en memoria.
   26/09/2026: la frase de «en stock» ya no va escrita aquí con 150 €; la trae sections/fa-quick en data-ok, con el
   umbral de envío gratis del canal de quien mira. */
(function () {
  var SEL = '.fa-qa [on\\:click="quick-add-component/handleClick"]';
  var cache = new Map();
  var reduce = matchMedia('(prefers-reduced-motion: reduce)');
  var dlg, slot, variants = [], seq = 0;

  function urlFor(qa) {
    var u = new URL(qa.dataset.url || '/', location.origin);
    u.searchParams.set('section_id', 'fa-quick');
    return u.pathname + u.search;
  }

  function load(url) {
    if (!cache.has(url)) {
      cache.set(url, fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('fa-quick ' + r.status); return r.text(); })
        .catch(function (e) { cache.delete(url); throw e; }));
    }
    return cache.get(url);
  }

  function ensure() {
    if (dlg) return;
    dlg = document.createElement('dialog');
    dlg.className = 'faq';
    dlg.setAttribute('aria-labelledby', 'faq-title');
    dlg.innerHTML = '<button type="button" class="faq__close" aria-label="Cerrar"><svg aria-hidden="true" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button><div data-faq-slot></div>';
    slot = dlg.querySelector('[data-faq-slot]');
    document.body.appendChild(dlg);

    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    dlg.addEventListener('click', onClick);
    // Añadido sin error: Horizon enseña su check en el botón y, al acabar, se cierra. Como con el «Añadir» de la tarjeta,
    // la cesta no se abre: se entera el contador. El nombre del evento es el estándar de @shopify/events, escrito a mano
    // porque este script no es un módulo y el import() dinámico no resuelve el mapa de importación desde aquí.
    dlg.addEventListener('shopify:cart:lines-update', function (e) {
      if (!e.promise) return;
      e.promise.then(function (r) {
        if (!(r && r.detail && r.detail.didError)) setTimeout(close, reduce.matches ? 400 : 900);
      }).catch(function () {});
    }, true);
  }

  function onClick(e) {
    var t = e.target;
    if (t === dlg) {
      // Clic en el velo: el <dialog> ocupa su caja, así que fuera de ella es fuera
      var r = dlg.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close();
      return;
    }
    if (t.closest('.faq__close')) return close();
    var v = t.closest('[data-faq-v]');
    if (v) return select(v.dataset.faqV, true);
    var q = t.closest('[data-faq-q]');
    if (q) {
      var input = dlg.querySelector('.faq__qty input');
      input.value = Math.min(99, Math.max(1, (parseInt(input.value, 10) || 1) + (+q.dataset.faqQ)));
    }
  }

  function showMedia(id, smooth) {
    var media = dlg.querySelector('[data-faq-media]');
    var shot = id && media && media.querySelector('[data-media-id="' + id + '"]');
    if (!shot) return;
    media.scrollTo({ top: shot.offsetTop, left: shot.offsetLeft, behavior: smooth && !reduce.matches ? 'smooth' : 'auto' });
  }

  function select(id, smooth) {
    var v = variants.find(function (x) { return String(x.id) === String(id); });
    if (!v) return;
    dlg.querySelectorAll('[data-faq-v]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.faqV === String(id))); });
    var form = dlg.querySelector('.faq__form');
    form.removeAttribute('data-faq-pending');
    form.querySelector('input[name="id"]').value = v.id;
    var opt = dlg.querySelector('[data-faq-opt]');
    if (opt) { opt.textContent = ': ' + v.option; opt.classList.remove('faq__hint'); }
    dlg.querySelector('[data-faq-price]').innerHTML = v.price;
    var add = dlg.querySelector('.faq__add');
    add.disabled = !v.available;
    dlg.querySelector('[data-faq-label]').textContent = v.available ? 'Añadir a la cesta' : 'Agotado';
    var stock = dlg.querySelector('[data-faq-stock]');
    stock.textContent = v.available
      ? (stock.dataset.ok || 'En stock, sale en 24 h.')
      : 'Agotado en ' + v.option + '. Elige otro o vuelve pronto.';
    var link = dlg.querySelector('.faq__title a');
    if (link && v.url) link.href = v.url;
    showMedia(v.media, smooth);
  }

  function open(qa, btn) {
    ensure();
    var root = document.documentElement;
    root.style.cursor = 'progress';
    // Si se pulsa otro «Échale un ojo» antes de que llegue este, gana el último
    var mine = ++seq;
    load(urlFor(qa)).then(function (html) {
      if (mine !== seq) return;
      slot.innerHTML = html;
      var data = slot.querySelector('[data-faq-variants]');
      variants = data ? JSON.parse(data.textContent) : [];
      if (dlg.open) dlg.close();
      dlg.showModal();
      var on = slot.querySelector('[data-faq-v][aria-pressed="true"]');
      var media = slot.querySelector('[data-faq-media]');
      if (media) media.scrollTo(0, 0);
      if (on) select(on.dataset.faqV, false);
    }).catch(function () {
      if (mine === seq) location.href = qa.dataset.url || '/collections/all';
    }).finally(function () { if (mine === seq) root.style.cursor = ''; });
  }

  function close() {
    if (!dlg || !dlg.open || dlg.classList.contains('is-closing')) return;
    var done = false;
    function end() { if (done) return; done = true; dlg.classList.remove('is-closing'); dlg.close(); }
    dlg.classList.add('is-closing');
    dlg.addEventListener('animationend', end, { once: true });
    setTimeout(end, 260);
  }

  addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(SEL);
    if (btn) {
      e.preventDefault(); e.stopImmediatePropagation();
      return open(btn.closest('.fa-qa'), btn);
    }
    // Con talla sin elegir el botón no compra: sacude las tallas y lleva el foco a la primera. Se corta aquí, en la
    // captura de la ventana, porque si llega a Horizon enseña el check de «añadido» sin haber añadido nada.
    var add = dlg && e.target.closest && e.target.closest('.faq__add');
    var form = add && add.closest('[data-faq-pending]');
    if (!form) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var opt = dlg.querySelector('.faq__opt');
    if (!opt) return;
    opt.classList.remove('is-nudge'); void opt.offsetWidth; opt.classList.add('is-nudge');
    var first = opt.querySelector('.faq__val:not([data-soldout])');
    if (first) first.focus();
  }, true);

  function prefetch(e) {
    var card = e.target.closest && e.target.closest('.fa-card, product-card');
    var qa = card && card.querySelector('.fa-qa');
    if (qa) load(urlFor(qa)).catch(function () {});
  }
  addEventListener('pointerover', prefetch, { passive: true });
  addEventListener('focusin', prefetch);
})();